<template>
  <div>
    <a-radio-group v-model="processor" @change="archChangeHandle">
      <a-radio-button v-for="item of processorTypeOpts" :value="item.key" :key="item.key">
        {{ item.label }}
      </a-radio-button>
    </a-radio-group>
    <vxe-grid
      row-id="id"
      ref="tableRef"
      min-height="260"
      resizable
      :columns="tableColumn"
      :data="skuResults"
      :radio-config="{ reserve: true }"
      @cell-click="skuChange"
      @radio-change="skuChange">
      <template v-slot:empty>
        <loader :loading="skuLoading" />
      </template>
    </vxe-grid>
    <div class="sku-pagebar">
      <vxe-pager
        :current-page.sync="skuPage.currentPage"
        :page-size.sync="skuPage.pageSize"
        :total="skuPage.totalResult"
        :layouts="['PrevJump', 'PrevPage', 'Jump', 'PageCount', 'NextPage', 'NextJump', 'Total']"
        @page-change="skuPageChangeHandle" />
      <div class="mt-1" v-if="selectedTip">{{$t('compute.text_171', [ selectedTip ])}}</div>
    </div>
  </div>
</template>

<script>
import { PROVIDER_MAP } from '@/constants'
import { sizestr } from '@/utils/utils'
import { Manager } from '@/utils/manager'
import {
  PROCESSOR_TYPE_ARCH_MAP,
} from '../constants'

export default {
  name: 'Sku',
  props: {
    provider: {
      type: String,
    },
    region: {
      type: String,
    },
    arch: {
      type: String,
    },
  },
  data () {
    return {
      PROCESSOR_TYPE_ARCH_MAP,
      processor: 'all',
      skuResults: [], // 套餐列表
      ratesList: [], // 套餐价格列表
      rateLoading: false,
      skuLoading: false,
      skuLoaded: false,
      selectedSkuData: {},
      skuPage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      skuTypes: [],
    }
  },
  computed: {
    processorTypeOpts () {
      return [{ key: 'all', label: this.$t('ai.common.all') }, ...this.PROCESSOR_TYPE_ARCH_MAP[this.arch]]
    },
    selectedTip () {
      if (this.selectedSkuData?.id) {
        return this.$t('compute.text_182', [
          this.selectedSkuData.name,
          this.$t('ai.common.custom'),
          this.selectedSkuData.cpu_count,
          sizestr(this.selectedSkuData.memory, 'M', 1024),
        ])
      }
      return null
    },
    tableColumn () {
      const columns = [
        { type: 'radio', width: 40 },
        {
          field: 'provider',
          title: this.$t('compute.text_176'),
          slots: {
            default: ({ row }) => {
              return [
                this.getHypervisor(row),
              ]
            },
          },
        },
        {
          field: 'processor_type',
          title: this.$t('ai.common.type'),
        },
        { field: 'cloudregion', title: this.$t('compute.text_177') },
        { field: 'name', title: this.$t('compute.text_178') },
        { field: 'cpu_count', title: this.$t('compute.text_179') },
        { field: 'cpu_arch', title: this.$t('compute.cpu_arch'), slots: { default: ({ row }) => { return row.cpu_arch || '-' } } },
        { field: 'memory', title: this.$t('compute.text_180'), slots: { default: ({ row }) => { return sizestr(row.memory, 'M', 1024) } } },
      ]
      return columns
    },
  },
  watch: {
    region () {
      this.fetchSkus()
    },
    arch () {
      this.processor = 'all'
      this.fetchSkus()
    },
    processor () {
      this.fetchSkus()
    },
  },
  created () {
    this.fetchSkus()
  },
  methods: {
    async fetchSkus () {
      try {
        this.clearSku()
        if (!this.region) return
        this.skuLoading = true
        const manager = new Manager('modelarts_pool_skus')
        const { data } = await manager.list({
          params: {
            limit: this.skuPage.pageSize,
            offset: (this.skuPage.currentPage - 1) * this.skuPage.pageSize,
            cloudregion: this.region,
            processor_type: this.processor === 'all' ? undefined : this.processor,
            cpu_arch: this.arch,
          },
        })
        this.skuResults = data.data
        if (this.skuResults && this.skuResults.length) {
          this.setSku(this.skuResults[0])
        }
        this.skuPage.totalResult = data.total
        this.skuLoaded = true
      } catch (error) {
        this.skuResults = []
        throw error
      } finally {
        this.skuLoading = false
      }
    },
    getHypervisor () {
      return this.provider ? PROVIDER_MAP[this.provider].label : PROVIDER_MAP.OneCloud.label
    },
    archChangeHandle () {},
    skuChange ({ row }) {
      this.setSku(row, true)
    },
    setSku (skuData) {
      const chooseSku = skuData
      this.$nextTick(() => {
        this.selectedSkuData = chooseSku
        this.$refs.tableRef && this.$refs.tableRef.setRadioRow(chooseSku)
        this.$emit('change', chooseSku)
      })
    },
    clearSku () {
      this.selectedSkuData = {}
      this.skuResults = []
      this.$emit('change', null)
    },
    skuPageChangeHandle ({ currentPage = 1, pageSize = 10 }) {
      this.skuPage = {
        ...this.skuPage,
        currentPage,
        pageSize,
      }
      this.fetchSkus()
    },
  },
}
</script>

<style lang="scss" scoped>
.sku-pagebar {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
}
</style>
